
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Operation } from './operation';
import { Apollo } from 'apollo-angular';
import { map as _map } from 'lodash';

const OperationsQuery = require('./gql/operations.query.gql');
const OperationsCategoriesQuery = require('./gql/operations-categories.query.gql');
const OperationQuery = require('./gql/operation.query.gql');
const createOperationMutation = require('./gql/create-operation.mutation.gql');
const updateOperationMutation = require('./gql/update-operation.mutation.gql');
const deleteOperationMutation = require('./gql/delete-operation.mutation.gql');

export interface OperationsQueryResult {
  operations: Operation[]
  operationsCount: number
}

export type OperationOrderBy = 'EXECUTIONS_COUNT' | 'NAME';
export type OperationOrderByDirection = 'ASC' | 'DESC';

export class OperationFilter {
  offset: number
  limit: number

  search = '';
  order_by: OperationOrderBy = 'EXECUTIONS_COUNT';
  order_direction: OperationOrderByDirection = 'DESC';
  start_date = '0';
  end_date = '0';
  category:string = null;
}

/**
 * Service to manage operations
 */
@Injectable()
export class OperationService {

  constructor(private apollo: Apollo) { }

  operations(filter: OperationFilter): Observable<OperationsQueryResult> {
    return this.apollo
      .query({
        query: OperationsQuery,
        variables: {
          filter
        },
        fetchPolicy: 'no-cache'
      }).pipe(
      map((result) => {
        let operationsData = result.data['operations'];
        let operationsCount = result.data['operationsCount'];

        let operations = _map(operationsData, operationData => new Operation(operationData));

        return {
          operations,
          operationsCount
        };
      }));
  }

  operationsCategories(): Observable<string[]> {
    return this.apollo
      .query({
        query: OperationsCategoriesQuery,
        fetchPolicy: 'no-cache'
      }).pipe(
      map((result) => {
        return result.data['operationsCategories'];
      }));
  }

  operation(id: string): Observable<Operation> {
    return this.apollo
      .query({
        query: OperationQuery,
        variables: {
          id
        }
      }).pipe(
      map(result => new Operation(result.data['operation'])));
  }

  create(operation: Operation): Observable<Operation> {
    return this.apollo
      .mutate({
        mutation: createOperationMutation,
        variables: {
          name: operation.name,
          category: operation.category,
        }
      }).pipe(
      map(result => new Operation(result.data['createOperation'])));
  }

  update(id: string, operation: Operation): Observable<Operation> {
    return this.apollo
      .mutate({
        mutation: updateOperationMutation,
        variables: {
          id,
          name: operation.name,
          category: operation.category,
        }
      }).pipe(
      map(result => new Operation(result.data['updateOperation'])));
  }

  delete(id: string): Observable<string> {
    return this.apollo
      .mutate({
        mutation: deleteOperationMutation,
        variables: {
          id
        }
      }).pipe(
      map(result => result.data['deleteOperation']));
  }
}